module.exports = __webpack_public_path__ + "static/media/6.83781bd0.jpg";